import React from "react";
import { useTranslation } from "react-i18next";
import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import type {
  PatientFlowData,
  PatientFlowChartProps,
} from "../../interfaces/components/patientFlowChart";

const PatientFlowChart: React.FC<PatientFlowChartProps> = ({ data }) => {
  const { t } = useTranslation();

  const options: ApexOptions = {
    chart: {
      type: "area",
      height: "100%",
      toolbar: {
        show: false,
      },
      background: "transparent",
    },
    theme: {
      mode: "dark",
    },
    colors: ["#3B82F6"],
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        opacityFrom: 0.7,
        opacityTo: 0.2,
        stops: [0, 90, 100],
      },
    },
    stroke: {
      curve: "smooth",
      width: 2,
    },
    grid: {
      borderColor: "rgba(255, 255, 255, 0.1)",
      strokeDashArray: 4,
      xaxis: {
        lines: {
          show: true,
        },
      },
    },
    xaxis: {
      categories: data.map((item) => item.month),
      labels: {
        style: {
          colors: "#9CA3AF",
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: "#9CA3AF",
        },
      },
    },
    tooltip: {
      theme: "dark",
    },
  };

  const series = [
    {
      name: t("dashboard.charts.patientFlow"),
      data: data.map((item) => item.total),
    },
  ];

  return (
    <div className="h-full">
      <ReactApexChart
        options={options}
        series={series}
        type="area"
        height="350"
      />
    </div>
  );
};

export default PatientFlowChart;
